import { render, staticRenderFns } from "./SpecialIconOval.vue?vue&type=template&id=2f959537&scoped=true&"
import script from "./SpecialIconOval.vue?vue&type=script&lang=js&"
export * from "./SpecialIconOval.vue?vue&type=script&lang=js&"
import style0 from "./SpecialIconOval.vue?vue&type=style&index=0&id=2f959537&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f959537",
  null
  
)

export default component.exports